
export default function(url, param = {}, cb = o => false, cache = true) {

    var supportsLocalStorage = 'localStorage' in window;

    // Both functions return a promise, so no matter which function 
    // gets called inside getCache, you get the same API. 

    var hash = url + JSON.stringify(param)

    function getJSON(url) {

        var promise = $.getJSON(url, param);

        promise.done(function(data) {
            localStorage.setItem(hash, JSON.stringify(data));
            cb(data)
        });

        // console.log('%c' + url + ' fetched via AJAX', 'color: orange');

        return promise;

    }

    function getStorage(url) {

        var storageDfd = new $.Deferred(),
            storedData = localStorage.getItem(hash);

        if (!storedData) {
            return getJSON(url, param);
        }

        setTimeout(function() {
            cb(JSON.parse(storedData))
            storageDfd.resolveWith(null, [JSON.parse(storedData)]);
        });

        // console.log('%c' + url + ' fetched via localStorange', 'color: blue');

        return storageDfd.promise();

    }

    return supportsLocalStorage ? getStorage(url) : getJSON(url);

}